import React from 'react'
import { Text } from "@paro.io/base-ui";
import { IconCheck } from "@paro.io/base-icons";

const benefits = [
    "Become your own boss",
    "Set your own rates",
    "Set your own hours",
    "Increase your earnings",
    "Pursue your passions",
    "Forget about selling",
    "Stop worrying about billing"
]

export default () => {
    return (
        <div className="hidden md:block pl-20">
            <Text className="mb-3">When you join Paro:</Text>
            <ul>
                {benefits.map(benefit =>
                    <li className="flex mb-2.5">
                        <IconCheck size="sm" className="h-18 mr-1.5 mt-1 text-tertiary" />
                        <p className="text-md">{benefit}</p>
                    </li>)}
            </ul>
        </div>);
}

